import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeFormData } from "../../../../../redux/slices";
import styles from "./Bible.module.scss";
import { IRootState } from "../../../../../redux/store";
import { getAvatarDefaultPrompt } from "../../../../../utils/shared";
import { AvatarPrompts, Gender, Names } from "../../../../../utils/types";
import { avatarPrompts } from "./constants";

interface Props {
	setIsSaveDisabled: (value: boolean) => void;
	setPromptText: (value: string) => void;
};

const MAX_CHAR_LIMIT = 1000;
const MIN_CHAR_LIMIT = 50;
const OVER_LIMIT_TEXT = `Превышено максимальное количество символов`;
const MIN_LIMIT_TEXT = `Кажется, текста маловато — нужно минимум 50 символов. Добавьте ещё немного!`
const MAX_HEIGHT = 515;
const OFFSET = 15;

export const Bible: React.FC<Props> = ({ setIsSaveDisabled, setPromptText }) => {
	const formData = useSelector((state: IRootState) => state.avatarForm);
	const {gender, name} = useSelector((state: IRootState) => state.avatar);
	const defaultText: string = getAvatarDefaultPrompt(gender as Gender, name as Names, avatarPrompts as AvatarPrompts);
	const [textareaValue, setTextareaValue] = useState<string>(formData.prompt || defaultText);
	const [isEditing, setIsEditing] = useState<boolean>(false);
	const isOverLimit = textareaValue.length >= (MAX_CHAR_LIMIT - 1);
	const isUnderLimit = textareaValue.length < (MIN_CHAR_LIMIT + 1);
	const isError = isOverLimit || isUnderLimit;
	const textareaRef = useRef<HTMLTextAreaElement>(null);
	const dispatch = useDispatch();

	useEffect(() => {
		if (!textareaRef.current) return;
		
		const textarea = textareaRef.current;
		
		textarea.style.height = "auto"; 
		const newHeight = Math.min(textarea.scrollHeight, MAX_HEIGHT);
		textarea.style.height = `${newHeight + OFFSET}px`;
	}, [textareaValue]);

	useEffect(() => {
		if (formData.prompt) {
			setTextareaValue(formData.prompt);
		}
	}, []);

	useEffect(() => {
		isError ? setIsSaveDisabled(true) : setIsSaveDisabled(false);
	}, [isError]);

	const handleBlur = useCallback(() => {
		setIsEditing(false);
	}, []);

	const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		const newValue = e.target.value;
		if (newValue.length < MIN_CHAR_LIMIT && newValue.length < textareaValue.length) {
			return;
		}
	
		if (newValue.length <= MAX_CHAR_LIMIT) {
			setTextareaValue(newValue);
			setPromptText(newValue);
		}
	};

	return (
		<div className={styles.bibleContainer}>
			<div className={styles.textContainer}>
				<h5>Промпт</h5>
				<span>Опиши роль и функцию своего аватара по шаблону ниже</span>
			</div>
			<textarea
				ref={textareaRef}
				value={textareaValue}
				onChange={handleChange}
				onBlur={handleBlur}
				onFocus={() => setIsEditing(true)}
				className={`${isError ? styles.overLimit : ""} ${isEditing ? styles.editing : ""}`}
			/>
			<span
				className={`${styles.description} ${isError ? styles.errorText : ""}`}
			>
				{isUnderLimit && MIN_LIMIT_TEXT}
				{isOverLimit && OVER_LIMIT_TEXT}
			</span>
		</div>
	);
};
